<template lang="html">
    <div class="types">
        <div class="container">
            <div class="row text-center">
                <div class="col">
                    <router-link :to="{name: 'index', params: {type: 'fotografie'}}"><span>Concursul de</span> fotografie</router-link>
                </div>
                <div class="col">
                    <router-link :to="{name: 'index', params: {type: 'videografie'}}"><span>Concursul de</span> videografie</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TypesMenu',
    components: {
    },
    props: {
    },
    computed: {
    },
    data: function() {
        return {}
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>

$yellow: #F7AD0C;
$black: #333333;
$grey: #E1E1E1;

.types {
    background: $yellow;

    a {
        display: inline-block;
        padding: 15px 10px;
        width: 100%;
        color: $black;
        font-weight: bold;

        &:hover {
            text-decoration: none;
        }

        @media (max-width: 768px) {

            text-transform: capitalize;

            span {
                display: none;
            }
        }
    }

    .router-link-active {
        background: $grey;
    }
}

</style>
